(function () {
  "use strict";

  var STORAGE_DISMISS = "tea_quiz_popup_dismissed_at";
  var STORAGE_COMPLETE = "tea_quiz_popup_completed_at";
  var root = null;
  var quizApi = null;
  var cfg = null;

  function daysSince(ts) {
    return (Date.now() - ts) / (1000 * 60 * 60 * 24);
  }

  function lsGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function lsSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* Safari private / blocked storage */
    }
  }

  function shouldAutoShow() {
    if (!cfg || cfg.enabled !== "true") return false;
    if (cfg.template !== "index") return false;
    if (window.location.pathname.indexOf("/pages/find-your-piece") === 0) return false;

    var completed = parseInt(lsGet(STORAGE_COMPLETE) || "0", 10);
    if (completed && daysSince(completed) < parseFloat(cfg.completedDays || "30")) return false;

    var dismissed = parseInt(lsGet(STORAGE_DISMISS) || "0", 10);
    if (dismissed && daysSince(dismissed) < parseFloat(cfg.dismissDays || "14")) return false;

    return true;
  }

  function openPopup(opts) {
    opts = opts || {};
    if (!root) return false;
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("tea-quiz-popup-open");
    if (opts.reset && quizApi && typeof quizApi.reset === "function") {
      quizApi.reset();
    }
    return true;
  }

  function closePopup(reason) {
    if (!root) return;
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("tea-quiz-popup-open");
    if (reason === "dismiss") lsSet(STORAGE_DISMISS, String(Date.now()));
    if (reason === "complete") lsSet(STORAGE_COMPLETE, String(Date.now()));
  }

  function isQuizEntryLink(el) {
    if (!el || !el.getAttribute) return false;
    if (el.hasAttribute("data-open-tea-quiz")) return true;
    var href = (el.getAttribute("href") || "").split("?")[0];
    if (!href) return false;
    return (
      href === "/pages/find-your-piece" ||
      href.indexOf("/pages/find-your-piece") !== -1 ||
      href === "#tea-quiz-popup" ||
      href === "#open-tea-quiz"
    );
  }

  function bindEntryLinks() {
    document.addEventListener(
      "click",
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var link = t.closest("a, button");
        if (!link || !isQuizEntryLink(link)) return;
        if (!root || cfg.enabled !== "true") return;

        var forced = link.hasAttribute("data-open-tea-quiz");
        var onHome = cfg.template === "index";
        /* On homepage: open modal instead of navigating. Elsewhere: only forced attrs. */
        if (!forced && !onHome) return;

        e.preventDefault();
        initQuizInner();
        openPopup({ reset: true });
      },
      true
    );
  }

  function initQuizInner() {
    if (!window.TEA_initQuiz || !root) return false;
    var inner = root.querySelector("[data-tea-quiz-popup-inner]");
    if (!inner) return false;
    if (quizApi) return true;

    quizApi = window.TEA_initQuiz(inner, {
      showIntro: true,
      fromPopup: true,
      introCta: (cfg && cfg.startLabel) || "Start quiz",
      onComplete: function () {
        lsSet(STORAGE_COMPLETE, String(Date.now()));
      },
    });
    return true;
  }

  function boot() {
    root = document.getElementById("tea-quiz-popup");
    if (!root) return;
    cfg = root.dataset;

    root.querySelectorAll("[data-popup-close]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        closePopup(btn.dataset.popupClose === "complete" ? "complete" : "dismiss");
      });
    });

    var overlay = root.querySelector(".tea-quiz-popup__overlay");
    if (overlay) {
      overlay.addEventListener("click", function () {
        closePopup("dismiss");
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("is-open")) closePopup("dismiss");
    });

    bindEntryLinks();
    window.TEA_openQuizPopup = function () {
      initQuizInner();
      return openPopup({ reset: true });
    };

    var tries = 0;
    function readyAndMaybeAuto() {
      if (!initQuizInner()) {
        if (tries++ < 40) {
          window.setTimeout(readyAndMaybeAuto, 50);
        }
        return;
      }

      if (!shouldAutoShow()) return;
      var delay = parseInt((cfg && cfg.delaySeconds) || "4", 10) * 1000;
      window.setTimeout(function () {
        if (!shouldAutoShow()) return;
        openPopup({ reset: false });
      }, delay);
    }

    readyAndMaybeAuto();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
